import { format } from 'date-fns';

export const dateOnly = (dateStr?: string): string => {
	if (!dateStr) return '';

	// Split the date string to get only the date part
	return dateStr.split('T')[0];
};

export const getPreviousDayUTC = (isoString: string) => {
	const date = new Date(isoString);
	date.setUTCDate(date.getUTCDate() - 1);
	// Split on 'T' to get only the date part
	return dateOnly(date.toISOString());
};

// Format dates for display
export const formatDate = (dateStr?: string, dateFormat = 'MMM dd'): string => {
	if (!dateStr) return '';

	try {
		// Split date to avoid timezone issues
		const datePart = dateOnly(dateStr);
		return format(new Date(`${datePart}T12:00:00Z`), dateFormat);
	} catch (error) {
		console.error(`Error formatting dateStr: ${dateStr}`, error);
		return dateStr;
	}
};
